// Feature flags for toggling surfaces without deleting code.
//
// Reviews surfaces (product-page ReviewsSection, standalone /ring/reviews
// page, rating badge on the product carousel, Reviews entry in
// SecondaryNavbar) are hidden when the visitor's region OR language is in
// the sets below. Hidden 2026-04-23 for JP / ja pending Bazaarvoice scope
// confirmation, JP-qualified legal sign-off on disclosure wording, and
// back-translation QA. Empty either set to restore the full reviews
// experience for that axis.
export const REVIEWS_HIDDEN_REGIONS = new Set(['JP']);
export const REVIEWS_HIDDEN_LANGUAGES = new Set(['ja']);

export function isReviewsSectionEnabled(args: {
  region?: string;
  language?: string;
}): boolean {
  const region = args.region?.toUpperCase();
  const language = args.language?.toLowerCase();
  if (region && REVIEWS_HIDDEN_REGIONS.has(region)) return false;
  if (language && REVIEWS_HIDDEN_LANGUAGES.has(language)) return false;
  return true;
}

// Same-Day / Next-Day Delivery on the Ring AIR buy page (badge, ETAs,
// India FAQ pincode copy). Module constant — rebuild to flip.
// false: warehouse "Dispatched by" only; no serviceability fetch, no
// campaigns delivery parse. true: still needs product_campaigns
// delivery.sdd_delivery_available.
export const SDD_NDD_BADGE_ENABLED = true;

// IN homepage 2-hour marketing card. Independent of SDD_NDD_BADGE_ENABLED
// (buy-page ETA badge, campaign parse, India FAQ). Rebuild to flip.
export const TWO_HOUR_HOMEPAGE_HERO_ENABLED = true;

// AE emirate-selector delivery ETA on the Ring AIR buy page (hides the
// warehouse shipping-estimate line entirely on AE and shows the window copy
// in every selection state, including engraving and open/sizing-kit size;
// short SDD/NDD line in the bottom bars and order summary).
// Independent of SDD_NDD_BADGE_ENABLED. Module constant — rebuild to flip.
export const AE_DELIVERY_ETA_ENABLED = true;

// AE homepage 4-hour marketing card, mutually exclusive with the IN 2-hour
// hero above (gated by region). Rebuild to flip.
export const FOUR_HOUR_HOMEPAGE_HERO_AE_ENABLED = true;

// Regions showing the Ring AIR promo copy under the buy-page price. Display
// only. Callers AND this with a live getCampaignForProduct('ring') so the copy
// retires with the discount; empty the set to hide it everywhere.
export const RING_AIR_PROMO_BANNER_REGIONS = new Set(['AE']);

export function isRingAirPromoBannerVisible(region?: string | null): boolean {
  const r = region?.toUpperCase();
  return !!r && RING_AIR_PROMO_BANNER_REGIONS.has(r);
}
